import styled from 'styled-components';
import PropTypes from 'prop-types';

import { useFnol } from '../../../context';

import { ReportTypeItem } from '.';

const ReportTypes = ({ onClick }) => {
  const { fnolTemplates, selectedFnolCategory } = useFnol();

  return (
    <>
      <ReportTypeList>
        {fnolTemplates &&
          fnolTemplates
            .filter(template => template.category.key === selectedFnolCategory)
            .map((template, index) => (
              <ReportTypeItem
                key={index}
                template={template}
                onClick={onClick}
              />
            ))}
      </ReportTypeList>
    </>
  );
};

ReportTypes.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ReportTypes;

const ReportTypeList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
